
enum Literals {
  NULL = 'null',
  N = 'N',

  TRUE = 'true',
  T = 'T',

  FALSE = 'false',
  F = 'F',

  Inf = 'Inf',
  PositiveInf = '+Inf',
  NegativeInf = '-Inf',

  NaN = 'NaN',
}

export default Literals;
